document.addEventListener('DOMContentLoaded', function () {

  const videos = document.querySelectorAll(
    'iframe.youtube-scroll-autoplay'
  );

  if (!videos.length) return;

  videos.forEach(function (iframe) {

    const observer = new IntersectionObserver(function (entries) {

      entries.forEach(function (entry) {

        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {

          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: 'playVideo',
              args: []
            }),
            '*'
          );

        } else {

          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: 'pauseVideo',
              args: []
            }),
            '*'
          );

        }

      });

    }, {
      threshold: [0, 0.5, 1]
    });

    observer.observe(iframe);

  });

});